<template>
    <div>
        <el-card>

            <el-table :data="tableData" border v-loading='loading'>

                <el-table-column type="index" width="50"></el-table-column>

                <el-table-column label="组织机构名称" prop="name"></el-table-column>

                <el-table-column label="操作" fixed="right">
                    <template slot-scope="scope">
                        <router-link :to="{ path: '/serveUser', query:{ id: scope.row.id, type: scope.row.type }}">
                            <el-button type="text" >用户</el-button>
                        </router-link>
                    </template>
                </el-table-column>

            </el-table>
            
        </el-card>
    
    </div>
</template>

<script>
import Pagination from '../../../components/Pagination'
import services from '../serve.services'

export default {

    components: { Pagination },

    data() {
        return {
            total: 10,
            loading: true,
            tableData: [],
            listQuery: {
                page_num: 1,
                page_size: 10
            },
            form: {}

        }
    },

    mounted() {
        this.request()
    },

    methods: {
        
        // 请求数据
        request() { 
            services.treeChildren({departmentId: '99999', type: 'group'})
                .then(res => this.tableData = res.list)
                .catch(err => this.$message.error(err.message))
                .finally(() => this.loading = false)
        },
    }
}
</script>

<style lang="scss" scoped>

</style>
